import React from "react";
import BackBtn from "../../Components/BackButton/BackButton";
import CheckMailPopUp from "../../Features/Forms/Components/CheckMailPopUp/CheckMailPopUp";

const MailCheckPage: React.FC = () => {
  return (
    <>
      <BackBtn></BackBtn>
    
      <CheckMailPopUp></CheckMailPopUp>
    </>
  );
};

export default MailCheckPage;
